export enum ModalDisplayMode {
	Create = 'CREATE',
	Read = 'READ',
	Update = 'UPDATE',
	Delete = 'DELETE',
	Print = 'PRINT',
}
